import React from "react";
import { RegisterOptions } from "react-hook-form";
import { FormItem, DateField } from "..";
import { DateControlProps } from "./DateControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";

function DateControl(props: DateControlProps) {
  const {
    defaultValue,
    getDateFieldProps,
    hideHelperText,
    label,
    name,
    required,
    validate,
    valuePropName,
    watchValue,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {
      validate,
    };
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    return result;
  }, [label, required, validate]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getDateFieldProps?.(params);
    },
    [getDateFieldProps]
  );

  return (
    <FormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      hideHelperText={hideHelperText}
      name={name}
      rules={rules}
      valuePropName={valuePropName}
      watchValue={watchValue}
    >
      <DateField {...other} label={label} />
    </FormItem>
  );
}

export default React.memo(DateControl);
